<form [formGroup]="fromUntilForm">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="from"
             class="control-label required">{{'i18n.shared.from' | translate}}</label>
      <ejs-datetimepicker formControlName="from"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [max]="maxDate">
      </ejs-datetimepicker>
      <app-error-messages [control]="fromUntilForm.controls.from"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="until"
             class="control-label">{{'i18n.shared.until' | translate}}</label>
      <ejs-datetimepicker formControlName="until"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [max]="maxDate">
      </ejs-datetimepicker>
      <app-error-messages [control]="fromUntilForm.controls.until"></app-error-messages>
    </div>
  </div>
</form>
